import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/views/searchbar";
import ViewsTable from "../../../containers/admin/views/table";
import { getUserVideosRequest } from "../../../modules/admin-modules/videos/Actions";

const Views = () => {
  const dispatch = useDispatch();
  const [phone, setPhone] = useState("");
  const [videoName, setVideoName] = useState("");

  useEffect(() => {
    dispatch(getUserVideosRequest({ phone }));
  }, [phone]);

  return (
    <Layout>
      <SearchBar phone={phone} setPhone={setPhone} videoName={videoName} setVideoName={setVideoName} />
      <ViewsTable videoName={videoName} />
    </Layout>
  );
};

export default Views; 